// @ts-nocheck
import { Navigate } from "react-router-dom"
import { MessagesClient } from "@/components/messages/MessagesClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function MessagesPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return <div className="h-[calc(100dvh-3.5rem)]"><MessagesClient userId={supabaseUser.id} /></div>
}